module.exports = __webpack_public_path__ + "static/media/hearts_3.9bacdfcd.png";